import { useCallback, useState } from "react";
import { AsyncState } from "../types/api";

type AsyncFn<TArgs extends unknown[], TResult> = (...args: TArgs) => Promise<TResult>;

export function useFetch<TArgs extends unknown[], TResult>(request: AsyncFn<TArgs, TResult>) {
  const [state, setState] = useState<AsyncState<TResult>>({
    data: null,
    isLoading: false,
    error: null,
  });

  const fetchData = useCallback(
    async (...args: TArgs) => {
      setState({ data: null, isLoading: true, error: null });
      try {
        const data = await request(...args);
        setState({ data, isLoading: false, error: null });
        return data;
      } catch (error) {
        setState({ data: null, isLoading: false, error });
        throw error;
      }
    },
    [request]
  );

  return { ...state, fetchData };
}
